import { render, staticRenderFns } from "./TariffOsagoItem.vue?vue&type=template&id=33af11e8&scoped=true&"
import script from "./TariffOsagoItem.vue?vue&type=script&lang=ts&"
export * from "./TariffOsagoItem.vue?vue&type=script&lang=ts&"
import style0 from "./TariffOsagoItem.vue?vue&type=style&index=0&id=33af11e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af11e8",
  null
  
)

export default component.exports